import { useState, useEffect } from 'react';
import { useTheme } from 'styled-components';
import Color from 'color';

const validateHexCode = color => {
  const VALID_LENGTHS = [3, 6];

  if (!color || !VALID_LENGTHS.includes(color.length)) return false;

  return /[0-9A-F]+/i.test(color);
};

const parseColorHash = (color, fallbackColor) => {
  if (!color) return fallbackColor;

  const parsedColor = color.replace('#', '');

  return validateHexCode(parsedColor) ? `#${parsedColor}` : fallbackColor;
};

export const useBannerColor = ({ primaryColor }) => {
  const { colors } = useTheme();

  const boardColor = parseColorHash(primaryColor, colors.primary[100]);
  const [textColor, setTextColor] = useState(colors.white);

  useEffect(() => {
    if (Color(boardColor).isDark()) {
      setTextColor(colors.white);
    } else {
      setTextColor(colors.black[100]);
    }
  }, [boardColor, colors.black, colors.white]);

  return { textColor, boardColor };
};
